export const employerRoutes = {
  dashboard: (id?: any) => (id && id > 0 ? `/employers/${id}/dashboard` : `/employers`)
};
